import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';

const Checklist = ({ open, onContinue, buttonLabel, onClose }) => {
  const [term1, setTerm1] = useState(false);
  const [term2, setTerm2] = useState(false);

  useEffect(() => {
    if (!open) {
      setTerm1(false);
      setTerm2(false);
    }
  }, [open]);

  if (!open) return null;

  const handleContinue = () => {
    onClose();
    onContinue();
  };

  return (
    <Modal
      open={open}
      title="Please accept the terms"
      onCancel={onClose}
      footer={null}
      maskClosable={false}
      keyboard={false}
      centered
    >
      <div onClick={(e) => e.stopPropagation()}>
        <div className="checklist-item">
          <label>
            <input type="checkbox" checked={term1} onChange={() => setTerm1(!term1)} />I agree to the Terms and
            Conditions.
          </label>
        </div>

        <div className="checklist-item">
          <label>
            <input type="checkbox" checked={term2} onChange={() => setTerm2(!term2)} />I have read and understood the
            Privacy Policy.
          </label>
        </div>

        <button
          className={`checklist-button ${term1 && term2 ? 'enabled' : 'disabled'}`}
          onClick={handleContinue}
          disabled={!(term1 && term2)}
        >
          {buttonLabel}
        </button>
      </div>
    </Modal>
  );
};

export default Checklist;
